// import commonEn from './common/en'

export default {
  save: 'Save',
  cancel: 'Cancel',
  copyright: 'Copyright© 2013-2026 WallTech Limited. All rights reserved',
  forTheRecord: '沪ICP备14001465号',
  success: 'Success',
  message: {
    inputRequired: 'Please input ',
    selectRequired: 'Please select ',
    userEmailRequired: 'Please input your e-mail account',
    userEmailFormat: 'Email format is incorrect',
    retrieveTips: 'After confirmation, an email will be sent to the mailbox for password reset',
    passwordFormat: 'Password must be 6-20 characters with uppercase, lowercase, and numbers',
    passwordNotMatch: 'The confirmed password must be consistent with the new password entered',
    passwordExpired: 'Su contraseña ha expirado. Contacte a su administrador para restablecerla antes de iniciar sesión.',
    ipNotAllowed: 'Su dirección IP {ip} no está permitida. Acceso denegado',
    oauthUserNotMatched: 'No se encontró ningún usuario de eTower que coincida con esta cuenta. Por favor, contacte a su administrador.',
    oauthServiceUnavailable: 'El servicio de identidad no está disponible temporalmente. Por favor, inténtelo de nuevo más tarde.',
    superAdminOnly: 'Solo las cuentas de superadministrador pueden iniciar sesión.',
    deviceNotRegistered: 'This browser or device is not registered. Access denied. To use a new browser, please contact IT',
    passwordChangeSuccess: 'Contraseña cambiada correctamente',
    passwordChangeFailed: 'Error al cambiar la contraseña',
    passwordResetSuccess: 'Contraseña restablecida correctamente. La nueva contraseña ha sido enviada al correo registrado del usuario.',
    passwordResetFailed: 'Error al restablecer la contraseña. Inténtelo de nuevo más tarde o contacte al administrador del sistema.',
    passwordResetConfirm: '¿Restablecer la contraseña de este usuario? Se generará una nueva contraseña según la política de contraseñas y se enviará a su correo registrado.',
    sendEmailFailed: 'Error al enviar el correo. Por favor, inténtelo de nuevo más tarde.'
  },
  login: {
    hello: 'Hello!',
    welcomeToSignIn: 'Welcome to Sign In',
    emailAccount: 'Email Account',
    password: 'Password',
    signIn: 'Sign In',
    signInWithMicrosoft: 'Iniciar sesión con Microsoft',
    thirdPartyLogin: 'Inicio de sesión de terceros',
    forgotPassword: 'Forgot password',
    chooseAnAccount: 'Choose an Account',
    retrievePassword: 'Retrieve Password',
    sendEmail: 'Send Email',
    back: 'Back',
    backToLoginPage: 'Back to login page',
    resetPassword: 'Reset Password',
    setPassword: 'Set Password',
    currentPassword: 'Current Password',
    logout: 'Logout'
  },
  common: {
    login: 'Login', // TODO
    loading: 'Loading...', // TODO
    sessionTimeout: 'Your session is timed out, please login again !', // TODO
    warning: 'Warning', // TODO
    backToLogin: 'Back to login', // TODO
    details: 'Detalles',
    copy: 'Copiar',
    translate: 'Traducir',
    info: 'Información',
    copySuccess: 'Copiado!',
    copyFailed: 'Copia fallida',
    error: 'Error', // TODO
    pleaseSelectLanguage: 'Seleccione idioma',
    userEmail: 'User Email'

  },
  spww: {
    home: 'Inicio',
    placeholder: 'Introduzca hasta 30 números de seguimiento, uno por línea',
    contactUs: 'Contáctenos: atcecommercesese@gruposese.com',
    noEventFound: 'Sin información disponible',
    languageSelect: 'Seleccione idioma',
    trackingNo: 'Numero de seguimiento',
    forFurtherInformation: 'Para más información'
  },
  nodes: {
    inf: 'Envío preparado',
    rcv: 'Escaneado en Origen',
    scn: 'Despachado en Origen',
    lhl: 'En tránsito',
    scnDes: 'En reparto',
    dld: 'Envío entregado'
  },
  navbar: {
    logOut: '退出',
    loginIn: '登录',
    changePassword: '修改密码',
    newPassword: '新密码',
    confirmpassword: '确认密码',
    passwordLabelWidth: '80px'
  }
}
